export default "__VITE_ASSET__BMY5ytVd__"